<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch04">
<a id="page24"></a>
<div class="chapterHead">
<h2 class="chapterTitle"><span class="xrefInternal"><a href="#/xhtml/contents#ch_04"><span class="bold"><span class="smallCaps">ODE TO THE PLANTAR FASCIA</span></span></a></span></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse">Latin cousin to Achilles,</p>
<p class="extractVerse">architectural upholder</p>
<p class="extractVerse">bearing its magisterial bundle</p>
<p class="extractVerse">beneath an imperial arch,</p>
<p class="extractVerse">rods around ax</p>
<p class="extractVerse">around</p>
<p class="extractVerse">axle and axis,</p>
<p class="extractVerse">staunch stanchion of the canonical self,</p>
<p class="extractVerse">aquiline and august,</p>
<p class="extractVerse">tensile, earthly, planted</p>
<p class="extractVerse">and wound in sinewed plaits,</p>
</div>
<div class="extract">
<p class="extractVerse">inverted hammock</p>
<p class="extractVerse">on which the body rests its burden</p>
<p class="extractVerse">like a red-faced tourist</p>
<p class="extractVerse">in the shadow</p>
<p class="extractVerse">of a coconut palm,</p>
</div>
<div class="extract">
<p class="extractVerse">only now is your grievance</p>
<p class="extractVerse">made known to me,</p>
<p class="extractVerse">only now do I hear your cry,</p>
<p class="extractVerse">unenviable membrane,</p>
<p class="extractVerse">faithful attendant upon my every stride,</p>
<p class="extractVerse">tender sole, antipodal to the soul,</p>
<a id="page25"></a>
<p class="extractVerse">pale mirror to the palm</p>
<p class="extractVerse">of this hand,</p>
</div>
<div class="extract">
<p class="extractVerse">only now do I honor your service,</p>
<p class="extractVerse">and my dignity is hobbled,</p>
<p class="extractVerse">only now do I learn to address you by name,</p>
</div>
<div class="extract">
<p class="extractVerse">and the Empire</p>
<p class="extractVerse">trembles.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?449cbeea